// FNP-534 / FNP-538: form-shape Zod schema for the MeteringRecords filter (read-only
// module). Backend-supported fields on MeteringRecordsFilterInput: state, customerId,
// meterId, meterCode, periodStartFrom, periodStartTo. The date-range bounds only
// narrow server-side when meterId is also set (they map to a key-condition on
// meter-period-index, PK meterId / SK periodStart — FNP-538); the form surfaces that
// dependency in its helper text rather than enforcing it, so a partial filter still
// returns the recordType-index list.
import {z} from 'zod';

export const FilterFormSchema = z.object({
    state: z.string().optional(),
    customerId: z.string().optional(),
    meterId: z.string().optional(),
    meterCode: z.string().optional(),
    periodStartFrom: z.string().optional(),
    periodStartTo: z.string().optional(),
});
